/**
 * @constructor
 * @returns {GameConfig}
 */
export default function GameConfig() {

    this.symbolPosY = -50;

    this.reelsPositions = [
        { 'x': 195 + 20, 'y': this.symbolPosY },
        { 'x': 485 + 10, 'y': this.symbolPosY },
        { 'x': 785 - 10, 'y': this.symbolPosY },
        { 'x': 1080 - 20, 'y': this.symbolPosY }
//		{ 'x': 244 * 4 + 122 + 30, 'y': this.symbolPosY }
    ];

    this.rowsCount = 3;

    this.symbolHeight = 184;
    this.symbolOffsetY = 10;

    this.hidePos = -9999;

    this.autoStartDelay = 0;

//	this.showPreinfo = false;
//
//	this.reelStopInitSound = 1;
//	this.reelStartInitSound = 1;
}